import React, { createContext, useState, useContext } from 'react';
import {MyContext} from './ProviderContext'

export const Navigation = () => {

    const { menuComponent, setMenuComponent } = useContext(MyContext);
    

    return (
        <>
            <div className="nav-bar">
                <div className="container-fluid">
                    <nav className="navbar navbar-expand-lg bg-dark navbar-dark">
                        <a href="#" className="navbar-brand">MENU</a>
                        <button type="button" className="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
                            <div className="navbar-nav mr-auto">
                                <a href="/" className={"nav-item nav-link " + menuComponent.home } >Home</a>
                                <a href="/About" className= {"nav-item nav-link " + menuComponent.about} >About</a>
                                <div className="nav-item dropdown">
                                    <a href="#" className={"nav-link dropdown-toggle " + menuComponent.services} data-toggle="dropdown">Services</a>
                                    <div className="dropdown-menu">
                                        <a href="/EngineeringDesign" className="dropdown-item">Engineering Design</a>
                                        <a href="/Construction" className="dropdown-item">Construction</a>
                                        <a href="/Procurement" className="dropdown-item">Strategic Procurement</a>
                                    </div>
                                </div>
                                <a href="/Team" className={"nav-item nav-link " + menuComponent.team}>Team</a>
                                <a href="/Project" className={"nav-item nav-link " + menuComponent.project} >Project</a>                                
                                <a href="/contact" className={"nav-item nav-link " + menuComponent.contact }>Contact</a>
                            </div>
                            <div className="ml-auto">
                                <a className="btn" href="/">Request Quote</a>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </>

    )
}